export const SESSION_STATUS = {
  WAITING: 0,
  PLAYING: 1,
  ENDED: 2,
};
